import React from 'react';
import {
    Create,
    SimpleForm,
    TextInput,
    NumberInput,
    ReferenceInput,
    AutocompleteInput,
    required,
} from 'react-admin';
import { FormToolbar } from '../../common/FormToolbar';

const initialValues = {
    code: '',
    productName: '',
    groupId: undefined,
    rate: 0,
};

export const ProductCreate = (props: any) => (
    <React.Fragment>
        <Create title="Create Product" {...props}>
            <SimpleForm
                warnWhenUnsavedChanges
                redirect="list"
                toolbar={<FormToolbar {...props} />}
                initialValues={initialValues}

                variant="outlined"
            >
                <TextInput source="code" label="Code" fullWidth validate={[required()]} />
                <TextInput source="productName" label="Product Name" fullWidth validate={[required()]} />
                <ReferenceInput
                    label="Product Group"
                    source="groupId"
                    reference="product-groups"
                    fullWidth
                >
                    <AutocompleteInput
                        optionText="designName"
                        fullWidth
                        resettable
                    />
                </ReferenceInput>
                <NumberInput source="rate" label="Rate" fullWidth  />
            </SimpleForm>
        </Create>
    </React.Fragment>
);
